<template>
  <div class="footer-wrapper">
    <footer class="footer">
      <div class="logo"></div>
      <div class="copyright-text" v-html="$t('LandingPage.footer')"></div>
      <a class="empty">|</a>
      <div class="wrapper">
        <a
          class="instagram"
          href="https://instagram.com/samsungtv?igshid=h0ul9mto2f8y"
          target="”_blank”"
        >@samsungtv</a>

        <span class="empty2">|</span>

        <a class="link" v-if="this.checkLang==='ko'">
          <router-link class="privacy" to="/privacypolicy">{{$t('PrivacyPolicy.title')}}</router-link>
        </a>
        <a class="link" v-else>
          <a
            class="privacy"
            href="https://account.samsung.com/membership/terms/privacypolicy"
            target="”_blank”"
          >{{$t('PrivacyPolicy.title')}}</a>
        </a>
      </div>

      <div class="select">
        <select @change="changeLocale">
          <option v-for="(item) in locales" :key="item.id" :value="item.id">{{item.text}}</option>
        </select>
      </div>
    </footer>
  </div>
</template>

<script>
import { language } from "@/util/language";
export default {
  components: {},
  data() {
    return {
      checkLang: ".",
      locales: [
        {
          id: "zh-CN",
          text: "中文",
        },
        {
          id: "zh-HK",
          text: "繁體中文(香港)",
        },
        {
          id: "zh-TW",
          text: "繁體中文(台灣)",
        },
        {
          id: "uk-UA",
          text: "Українська",
        },
         {
          id: "vi",
          text: "Tiếng Việt",
        },
        {
          id: "sv",
          text: "Svenska",
        },
        {
          id: "fi",
          text: "Suomi",
        },
         {
          id: "sk",
          text: "Slovensko",
        },
        {
          id: "sl",
          text: "Slovenščina",
        },
        {
          id: "sq",
          text: "Shqip",
        },
         {
          id: "ro",
          text: "Romanian",
        },
        {
          id: "ru",
          text: "Русский",
        },
        {
          id: "pt",
          text: "Português",
        },
        {
          id: "pl",
          text: "Polski",
        },
        {
          id: "no",
          text: "Norsk",
        },
        {
          id: "mk",
          text: "Македонски",
        },
        {
          id: "hu",
          text: "Magyar",
        },
        {
          id: "lt",
          text: "Lietuvių",
        },
        {
          id: "lv",
          text: "Latvian",
        },
         {
          id: "it",
          text: "Italiano",
        },
        {
          id: "hr",
          text: "Hrvatski",
        },
         {
          id: "gr",
          text: "Ελληνικά",
        },
        {
          id: "fr",
          text: "Français",
        },
        {
          id: "es",
          text: "Español(Latin America)",
        },
        {
          id: "es-ES",
          text: "Español(Europe)",
        },
        {
          id: "en",
          text: "English",
        },
        {
          id: "et",
          text: "Eesti",
        },
        {
          id: "de",
          text: "Deutsch",
        },
         {
          id: "da",
          text: "Dansk",
        },
        {
          id: "sr",
          text: "Cрпски",
        },
        {
          id: "cs",
          text: "Česká republika",
        },
        {
          id:"bg",
          text:"Български"
        },
        {
          id: "bs",
          text: "Босански",
        },
        {
          id: "ko",
          text: "한국어",
        },
      ],
    };
  },
  created() {
    const lang = language.getLanguage();
    this.locales = this.locales.sort((a, b) => {
      return a > b ? 1 : -1;
    });
    this.locales = this.locales.sort((a) => {
      return a.id === lang ? -1 : 0;
    });
    this.checkLang = language.getLanguage();
    this.$forceUpdate();
  },
  methods: {
    changeLocale(e) {
      window.scrollTo(0, 0);
      this.$i18n.locale = e.target.value;
      document.querySelector("html").setAttribute("lang", e.target.value);
      language.setLanguage(e.target.value);
      if(this.$route.path == "/search"){
        this.$emit('countryChange');
      } else {
        location.reload();
      }      
    },
  },
};
</script>

<style scoped>
.footer-wrapper {
  background-color: black;
}

.footer {
  height: 100px;
  background-color: black;
  color: white;
  display: flex;
  justify-content: flex-start;
  max-width: 1200px;
  margin: auto;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: content-box;
  line-height: 1;
  position: relative;
  /* position:relative; */
}

.copyright-text {
  color: #9f9f9f;
  font-size: 12px;
  line-height: 1.4;
  text-align: left;
  margin-left: 20px;
  margin-top: 0px;
  position: relative;
  max-width: 650px;
}
.copyright-text dl {
  margin: 0;
}
.copyright-text dd {
  margin: 0;
}
.select {
  position: absolute;
  width: 180px;
  height: 30px;
  right: 30px;
  /* right:-405px; */
  /* float:right; */
  /* right:250px; */
}
.select select {
  background-color: black;
  /* color: white; */
  border: 1px solid #aaaaaa;
  border-radius: 0;
  width: 180px;
  height: 30px;
  color: #aaaaaa;
  padding-left: 20px;
  padding-right: 20px;
}

.select::after {
  /* background-color: black; */
  /* color: white; */
  content: " ";
  border-top: 2px solid #aaaaaa;
  border-left: 2px solid #aaaaaa;
  width: 5px;
  height: 5px;
  border-radius: 0;
  right: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-40%) rotate(45deg);
  color: #aaaaaa;
}
.logo {
  width: 104px;
  height: 16px;
  background-image: url("../../assets/logo.svg");
  background-repeat: no-repeat;
}
.instagram {
  color: #9f9f9f;
  text-decoration: underline;
  cursor: pointer;
  height: 20px;
  font-size: 12px;
  position: relative;
}
.privacy {
  color: #9f9f9f;
  text-decoration: underline;
  cursor: pointer;
  height: 20px;
  font-size: 12px;
  /* float:left; */
  /* position:absolute; */
  /* visibility:hidden; */
}
.empty {
  width: 30px;
  text-align: center;
  height: 20px;
  opacity: 1;
  color: #9f9f9f;
}
.empty2 {
  display: inline-block;
  width: 30px;
  text-align: center;
  height: 20px;
  opacity: 1;
  color: #9f9f9f;
}
.link {
  height: 20px;
  position: absolute;
}

@media (max-width: 1024px) {
  .footer {
    height: auto;
    margin: auto;
    padding: 0;
    padding-top: 30px;
    flex-direction: column;
    /* padding-left: 20px;
    padding-right: 20px;
     */
    position: relative;
    max-width: 83.33vw;
    /* padding-bottom: 10px; */
    align-items: flex-start;
    /* justify-content: flex-end; */
  }
  .select select {
    font-size: 0.7rem;
    width: 100px;
    height: 20px;
    padding-left: 10px;
    /* font-family: "SamsungSharpSans"; */
  }
  .select {
    width: 100px;
    height: 20px;
    position: absolute;
    /* margin-left:-110px; */
    right: 0px;
    top: 25px;
  }
  .select::after {
    /* background-color: black; */
    /* color: white; */
    content: " ";
    width: 3px;
    height: 3px;
  }
  .privacy {
    font-size: 0.8rem;
    width: 180px;
    text-align: left;
    /* position:absolute; */
  }
  .logo {
    width: 80px;
    height: 12.3px;
    /* right: 50px; */
    background-image: url("../../assets/logo.svg");
  }
  .copyright-text {
    font-size: 0.8rem;
    margin-top: 20px;
    margin-bottom: 10px;
    position: relative;
    margin-left: 0;
  }
  .empty {
    display: none;
  }
  .empty2 {
    display: inline-block;
    width: 30px;
    height: 20px;
    font-size: 0.8rem;
    opacity: 1;
  }
  .instagram {
    font-size: 0.8rem;
    height: 20px;
    position: relative;
  }
  .wrapper {
    width: 150px;
    position: relative;
    flex-direction: row;
    align-items: flex-start;
    text-align: left;

    /* position:relative; */
  }
  .link {
    width: 190px;
    height: 20px;
    position: absolute;
  }
}
</style>
